/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title: string = 'ascendiun';
  constructor(private router: Router) {}

  get isHomePage(): boolean {
    return this.router.url === '/' || this.router.url === '';
  }

  readonly mail_text: string = "mailto:contactus@ascendiun.com?subject=Ascendiun Inquiry";
}
